import { AppointmentPDF } from '@avanta/shared/components/AppointmentPDF';
import { Button, type buttonVariants } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { t } from '@avanta/shared/i18n';
import { cn } from '@avanta/shared/utils/cn';
import { type VariantProps } from 'class-variance-authority';
import { FileText } from 'lucide-react';
import { useUserStore } from 'stores/user';
import { type Appointment } from 'types/appointments';
import { openPDF } from 'utils/storage';

interface DownloadAppointmentPDFProps {
  appointment: Appointment;
  icon?: VariantProps<typeof buttonVariants>['icon'];
  buttonLabel?: string;
  className?: string;
}

export const DownloadAppointmentPDF = ({
  appointment,
  icon,
  buttonLabel = t('DownloadAppointmentPDF.cta', { ns: LOCIZE_NS.APPOINTMENTS }),
  className,
}: DownloadAppointmentPDFProps): React.ReactElement | null => {
  const patient = useUserStore(state => state.user);

  if (!patient) return null;

  const handleDownloadAppointmentPdf = async (): Promise<void> => {
    openPDF({
      pdfComponent: <AppointmentPDF appointment={appointment} patient={patient} />,
      filename: appointment.dateTime,
    });
  };

  return (
    <Button
      variant="terciary"
      className={cn('hover:bg-blue-100 hover:border-blue-300 hover:text-blue-700', className)}
      size="md"
      onClick={handleDownloadAppointmentPdf}
      icon={icon ?? 'leading'}
    >
      <FileText className="size-3" />
      {icon !== 'only' && buttonLabel}
    </Button>
  );
};
